import { GridState } from 'ag-grid-community';

const prefix = '[ManagementApplications]';

export class SetGridState {
    static readonly type = `${prefix} Set Grid State`;
    constructor(public gridState?: GridState) {}
}

export class SetInfiniteInitialRowCount {
    static readonly type = `${prefix} Set Infinite Initial Row Count`;
    constructor(public infiniteInitialRowCount?: number) {}
}

export class SetQuickFilterValue {
    static readonly type = `${prefix} Set Quick Filter Value`;
    constructor(public quickFilterValue: string | null) {}
}

export class DeleteApplication {
    static readonly type = `${prefix} Delete Application`;
    constructor(public applicationId: string) {}
}
